module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-relax-bg-shenzhen-h5.223cd691.jpg";